import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article5() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });


  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      var img2 = document.getElementById("img2");
      img2.className = '';

      return "";
    }

    else if (secondInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = 'active';

      return "";
    }
  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article6');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article4');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article5-left-img1.jpg")} />
          <img id="img2" className={getAnimationClass()} src={require("../../Images/article5-left-img2.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">
          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article5-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
          <div className="" ref={firstContainer}>
            <div
              variants={textAnimate}
            >

              <h1 className="f-lora text-red fs-xl mb-4">SIGNS of <br/>the TIMES</h1>

            </div>
            <p className="font-italic mb-0" variants={textAnimate}>words // Alyn Griffiths - photography // Simon Hird</p>
            <hr className="mb-4 mb-sm-5 text-red" />
            <div variants={textAnimate} className="row mb-4">
              <div className="col-sm-6">
                <p className="mb-4">Walk down any typical high street in Scotland today and you will no doubt notice the overwhelming number of signs vying for your attention with their gaudy colours and eye-catching fonts. It wasn’t always this way, however. Photographs of town centres that pre-date the availability of cheaply printed signage depict beautifully painted shops decorated by skilled signwriters who used a limited number of lettering styles and traditional techniques to present basic information about a building’s occupants.</p>
                <p className="mb-4">Our high streets are constantly evolving and recently there has been an increase in the number of independent businesses occupying premises vacated by chain retailers, banks and other companies that are choosing to focus on their online presence. These local boutiques, barbers, beauty salons, cafés and restaurants are more likely to invest in quality signage that reflects the values of their brand in order to make a good first impression on customers. That means more work for the small community of signwriters who continue to practice a trade that often goes unnoticed but can have a powerful subliminal appeal.</p>
              </div>
              <div className="col-sm-6">
                <img className="img-fluid mt-3"
                  src={require("../../Images/article5-right-img1.jpg")}
                />
              </div>
            </div>

            <img className="img-fluid mb-4"
              src={require("../../Images/article5-right-img2.jpg")}
            />
            
            <div className="row mb-4 mb-sm-5">
              <div className="col-sm-6">

                <p className="" variants={textAnimate}>“A hand-painted sign has a perceived sense of quality and tradition that is still universally understood,” says Thomas Payne, who is part of a new generation of signwriters helping to create contemporary, Instagrammable designs for clients looking to add a personal touch to their shopfronts. The 35-year-old, who has adopted the playful moniker ‘Thomas Paints’, can often be spotted perched on a ladder with his palette and brushes in Edinburgh, the Lothians and occasionally further afield, or glimpsed through a shop window applying gold-leaf lettering to the inside of the glass. Since launching his business in 2015, he has painted hundreds of hanging signs, windows and shopfronts, as well as working on more quirky commissions such as decorating a pizza delivery truck or creating a mural for Hibernian Football Club. When asked about his reasons for pursuing such an unusual and specialist career path, he answers straightforwardly, “I just like looking at nice signs.” Dig a little deeper, though, and there is more to the story.</p>
                <p className="" variants={textAnimate}>Payne gained a B.A. Hons in Furniture Design and a Masters degree in Product Design from Edinburgh College of Art before working his way up through various agency roles. One year, his wife bought him set of brushes and some paints for Christmas and suggested he try his hand</p>

              </div>
              <div className="col-sm-6">

                <p className="" variants={textAnimate}>at making some signs for an exhibition. “I was bored with working on a computer all the time,” says Payne, speaking from his workshop and studio in Longniddry, which is filled with old signs he collects to inspire his work. He is now so dedicated to his craft that he is on a mission to paint every sign in the village, and even offers his services for free if local businesses can’t afford to hire him. “If I see a sign that’s ugly or deteriorating it drives me bananas,” he says, pointing to projects for the village shop and primary school as examples of his pro bono work. “It’s good to give something back to the neighbourhood, although I’m really doing it for me so I don’t have to look at bad signs,” he jokes.</p>

                <p className="" variants={textAnimate}>Payne’s process combines traditional painting skills with his design background, which allows him to create bespoke signs with a modern or classic feel. He uses computer software to develop ideas with his clients and prepare them for painting, but once he’s up on the ladder the process is much the same as it would have been for sign painters a century ago. The designs are plotted onto paper using a special printer that pierces tiny holes in the surface. The stencil is then fixed to the surface and chalk dust is blown through the holes to create a temporary outline that provides a guide for painting (a modern version of a traditional technique known as pouncing). </p>
              </div>
            </div>
            
          </div>

          <div className="" ref={secondContainer}>
            <img className="img-fluid mb-4 mb-sm-5"
              src={require("../../Images/article5-right-img3.jpg")}
            />
            <div className="row mb-4 mb-sm-5">
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>Payne uses quill-shaped sable brushes to apply durable oil-based enamel paints from a wooden palette, resting his painting hand on a mahl stick to prevent slippage and to keep it away from the wet paint as he works. He says his goal is not to paint perfectly, but rather to leave “flair and bounce and fluidity” in the shapes and lines he produces. “After years of painting, my eyes are tuned to what a wellpainted letter should look like,” he claims. “It still needs to look neat but I like the edges to be subtly curved or flared to retain that hand-painted feel.”</p>
                <p className="" variants={textAnimate}>The results speak for themselves and Payne’s clients clearly recognise the value that a hand-painted sign brings to their business. Florist Rebecca Henderson, who commissioned Payne to decorate the frontage of her shop on South Queensferry’s historic High Street, says she gave him free rein to design the signage and was delighted with how it turned out. “I wanted my sign to be more than just a name above a shop,” she explains, adding:</p>

              </div>
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>“It needed to uphold the traditional features of the building and the High Street. The design and style Thomas came up with just feel right here.” For Payne, helping business owners to realise such an important aspect of their branding provides him with moments of supreme satisfaction. “I’ve had several clients look at a sign I’ve painted and just burst into tears,” he says with a grin. “It’s definitely not why I do it but that’s a really nice feeling.”</p>

                <p className="" variants={textAnimate}>The majority of Payne’s work involves painting onto signboards or shopfronts but he also takes on more unusual commissions, such as adding lettering to tiled roofs or applying a logotype to the side of the towering 40-metre-tall Port of Leith distillery in Edinburgh. Working out the logistics of how to accurately transfer his designs onto these awkward surfaces is one aspect of his craft that Payne finds particularly rewarding. “I love figuring out how to paint on something that’s a bit unique or hard to get to,” he says. This claim is backed up</p>
              </div>
            </div>

            <div className="row align-items-center mb-4 mb-sm-5">
              <div variants={textAnimate} className="col-sm-6">
                <h2 className="mb-4 text-red f-lora pe-3 lh-base">“A hand-painted sign has a perceived sense of quality and tradition that is still universally understood”</h2>
              </div>
              <div variants={textAnimate} className="col-sm-6">
                <img className="img-fluid"
                  src={require("../../Images/article5-right-img4.jpg")}
                />
                
              </div>
            </div>

            <div className="row mb-4 mb-sm-5">
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>by the case studies featured on his website, which include examples of signage expertly painted onto brick, corrugated cladding, harling, roofs and rough stone walls. If you can paint on it, he’ll find a way. </p>
                <p className="" variants={textAnimate}>In addition to sign painting, a few years ago Payne taught himself the traditional craft of glass gilding; applying sheets of 23-and-a-half-carat gold leaf to glass using water to produce a lustrous mirror finish. “The Victorians used gold leaf to add decorative elements to shop fascias because it’s UV stable and it will never fade,” he explains, adding that he learned by practising on pieces of glass purchased at charity shops. In addition to gilding shop windows, Payne spends most Fridays working on house numbers, which he says are a great way to end the week because “they’re often the finishing touch to someone’s home renovations and it’s lovely to see a client’s happy face when they’re done.”</p>

              </div>
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>Almost eight years into his sign painting venture, Payne is currently busier than ever, with between 30 and 40 active projects ongoing at any given time. He employs an assistant to help him complete many of his larger jobs and his client list now includes important institutions such as the National Museum of Scotland and the Royal Botanic Gardens in Edinburgh. He admits that he entered into the profession at a good time and has been aided by the rise of social media, which is a useful tool for promoting his work. He has over 10,000 followers on Instagram, who delight in his quirky posts including oddly satisfying videos of him slowly pulling off masking tape to reveal clean paint lines on various surfaces.</p>
                <p className="" variants={textAnimate}>Despite all of his success to date, Payne remains grounded and focused on a simple yet important objective. “I just want to make shops and high streets more attractive with well considered designs,” he insists, modestly. With his help, our town centres might just regain some of their former glory</p>
              </div>
            </div>

          </div>


          </div>



        </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article5;
